module.exports = __webpack_public_path__ + "static/media/ins12.ed441038.jpg";